import axios from 'axios';
export class ApiClient {
    constructor(config) {
        this.config = config;
        this.instance = axios.create({
            baseURL: config.baseApiUrl,
            timeout: config.timeout || 30000,
            headers: {
                'Content-Type': 'application/json',
            },
        });
        this.setupInterceptors();
    }
    setupInterceptors() {
        this.instance.interceptors.request.use((config) => {
            if (this.config.accessToken) {
                config.headers.Authorization = `Bearer ${this.config.accessToken}`;
            }
            return config;
        }, (error) => {
            return Promise.reject(error);
        });
        this.instance.interceptors.response.use((response) => response, (error) => {
            var _a, _b, _c, _d, _e;
            const appError = {
                code: ((_b = (_a = error.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.error_code.toString()) ||
                    error.code ||
                    'UNKNOWN_ERROR',
                message: ((_d = (_c = error.response) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.error) ||
                    error.message ||
                    'An unknown error occurred',
                details: (_e = error.response) === null || _e === void 0 ? void 0 : _e.data,
            };
            return Promise.reject(appError);
        });
    }
    async get(url, config) {
        const response = await this.instance.get(url, config);
        return response.data;
    }
    async post(url, data, config) {
        const response = await this.instance.post(url, data, config);
        return response.data;
    }
    async put(url, data, config) {
        const response = await this.instance.put(url, data, config);
        return response.data;
    }
    async delete(url, config) {
        const response = await this.instance.delete(url, config);
        return response.data;
    }
    async patch(url, data, config) {
        const response = await this.instance.patch(url, data, config);
        return response.data;
    }
    getAxiosInstance() {
        return this.instance;
    }
}
